import { useSelector } from "react-redux";

export function usePermissions() {
  return useSelector((state) => state.permissions);
}
